<template>
  <div>
    <jala-region-select-ajax
      name="region_id"
      v-model="value.region_id"
      @update:selected="(value) => onFarmRegionUpdated(value)"
      required
      :disables="regionDisables"
      :rules="regionRules"
    ></jala-region-select-ajax>
    <div class="row">
      <validation-provider
        :vid="`customers.total_person`"
        :name="lodash.startCase($t('customers.total_person'))"
        v-slot="{ validated, errors }"
        class="col-md-6"
        rules="min_value:0"
      >
        <b-form-group
          class="row mb-3"
          label-cols-md="12"
          :label="`${lodash.startCase($t('customers.total_person'))}`"
          :state="errors[0] ? false : validated ? true : null"
          :invalid-feedback="errors[0]"
        >
          <b-form-input
            :name="lodash.startCase($t('customers.total_person'))"
            type="number"
            required
            :state="errors[0] ? false : validated ? true : null"
            v-model="value.total_person"
            @mousewheel.native="$event.preventDefault()"
          ></b-form-input>
        </b-form-group>
      </validation-provider>
      <validation-provider
        vid="address"
        :name="lodash.startCase($t('customers.full_address'))"
        rules="required"
        v-slot="{ validated, errors }"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.startCase($t('customers.full_address'))"
            :state="errors[0] ? false : validated ? true : null"
            class="row mb-3"
            label-class="required-indicator"
            label-cols-md="12"
        >
        <b-form-textarea
            name="address"
            type="text"
            :state="errors[0] ? false : validated ? true : null"
            v-model="value.address"
            :disabled="addressDisabled"
          ></b-form-textarea>
        </b-form-group>
      </validation-provider>
      <div class="col-12">
        <customer-coordinate
            :card-title="locationCardTitle"
            :farm="value"
            :region="value.region"
        />
      </div>
    </div>
  </div>
</template>

<script>
import JalaRegionSelectAjax from "@/components/forms/customer/jala-region-select-ajax.vue";
import CustomerCoordinate from "@/components/forms/customer/customer-coordinate.vue";

export default {
  name: "customer-office",
  components: {
    CustomerCoordinate,
    JalaRegionSelectAjax,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        region_id: null,
        region_full_name: "",
        region: null,
        get coordinate() {
          return this.latitude ? `${this.latitude},${this.longitude}` : null;
        },
        set coordinate(value) {
          if (value) {
            const [lat, lng] = (value || "").split(",");
            if (lat != null && Number(lat) && lng != null && Number(lng)) {
              this.latitude = Number(lat);
              this.longitude = Number(lng);
            }
          } else {
            this.latitude = null;
            this.longitude = null;
          }
        },
      }),
    },
    locationCardTitle: {
      type: String,
      default: function () {
        return this.$t('customers.location')
      },
    },
    disableAddress: {
      type: Boolean,
      default: false,
    },
    disableAddressWhenVillageSelected: {
      type: Boolean,
      default: false,
    },
    disableRegionSelectWhenVillageSelected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      regionRules: {
        province: "required",
        regency: "required",
        district: "required",
        village: "required",
      },
      isAddressInitiallyEmpty: !this.value.address,
    }
  },
  computed: {
    addressDisabled() {
      if (this.disableAddress) {
        return true;
      }

      if (this.isAddressInitiallyEmpty) {
        return false;
      }

      return this.disableAddressWhenVillageSelected && this.isUntilVillageRegion(this.value.region_id);
    },
    regionDisables() {
      if (this.disableRegionSelectWhenVillageSelected && this.isUntilVillageRegion(this.value.region_id)) {
        return ["province", "regency", "district", "village"];
      }

      return [];
    },
  },
  methods: {
    onFarmRegionUpdated(event) {
      if (event) {
        this.$set(this.value, "region_full_name", event.full_name);
      }
    },
    isUntilVillageRegion(regionId) {
      return regionId && regionId.length === 10;
    },
    emitInput() {
      this.$emit("input", this.value);
    },
  },
  deactivated() {
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  legend.required-indicator::after {
    content: ' *';
    color: #DC2626;
  }
}
</style>
